import { Page } from "src/components";

export const PageImagineMacrospace = () => {
  return (
    <Page>
      <iframe
        src={import.meta.env.VITE_CHATBOT_URL as string}
        style={{ width: "100%", height: "100%" }}
      />
    </Page>
  );
};
